<template>
    <!-- *******************************DETALLES DE LA OFERTA***********************************-->
  <transition name="offer-fade">
    <div class="offer__details" v-if="offer.id">
      <we-tabs ref="tabs">
        <we-tab class="we-tab" :name="admin && windowWidth < 992 ? 'Oferta' : 'Datos de la Oferta'" :selected="!openHistory">
          <div class="details-grid">
            <div class="hidden-desktop">
              <div class="info-grid-label">
                Estado de la oferta
              </div>
              <div class="info-grid-value">
                {{ $t(`offer.state.${offer.state}`) }}
              </div>
            </div>

            <div
              class="hidden-desktop"
              v-if="
                ['published', 'in_negotiation', 'pending'].includes(
                  offer.state
                ) &&
                  !!getPendingNegotiations(offer) &&
                  !admin
              "
            >
              <div class="info-grid-label">
                Acción
              </div>
              <div class="info-grid-value">
                <span
                  >{{
                    getPendingNegotiations(offer) > 1
                      ? getPendingNegotiations(offer) + " pendientes"
                      : "Pendiente"
                  }}
                  de respuesta</span
                >
              </div>
            </div>

            <div>
              <div class="info-grid-label">
                Semana de entrega
              </div>
              <div class="info-grid-value">
                {{ formatWeek(offer.week) }}
              </div>
            </div>

            <div>
              <div class="info-grid-label">
                {{
                  "Cantidad de animales"
                }}
              </div>
              <div
                class="info-grid-value quantity-left"
                :class="{ negotiable: offer.subtype != 'order_muvin' ? offer.negotiableAttributes.quantity : '' }"
              >
                <div class="wrapper">
                  <span v-if="activeState">
                    <span v-html="showQuantityLeft"></span>
                  </span>
                  <span v-else class="quantity">
                    {{ offer.quantity }}
                  </span>
                  <span style="color: green" v-if="offer.subtype === 'muvin' && offerFinalQuantity() > offer.quantity" class="quantity">
                    +{{ offerFinalQuantity() - offer.quantity }}
                  </span>
                  <span style="color: #e30000;" v-if="offer.subtype === 'muvin' && offerFinalQuantity() != null && offerFinalQuantity() < offer.quantity" class="quantity">
                    {{ offerFinalQuantity() - offer.quantity }}
                  </span>
                </div>
              </div>
            </div>

            <div v-if="offer.subtype === 'order_muvin'">
              <div class="info-grid-label">{{"Cantidad final de animales"}}</div>
              <div class="info-grid-value quantity-left">
                <div class="wrapper">
                  <span class="quantity">{{ offerFinalQuantity() != null ? offerFinalQuantity() : '-'}}</span>
                </div>
              </div>
            </div>

            <div>
              <div class="info-grid-label">
                Precio inicial sin IVA
              </div>
              <div class="info-grid-value">
                <div class="wrapper">
                  {{ localePrice(offer.price) }}
                </div>
              </div>
            </div>

            <div v-if="offer.subtype === 'order_muvin'">
              <div class="info-grid-label">
                Peso faena
              </div>
              <div class="info-grid-value">
                <span v-if="offer.quality.slaughterWeight">{{ localeNumber(offer.quality.slaughterWeight) }} (± 5) Kgs</span>
              </div>
            </div>

            <div>
              <div class="info-grid-label">
                Categoría
              </div>
              <div class="info-grid-value">
                {{ offer.category.name | mei}}
              </div>
            </div>

            <div v-if="offer.kilometers === 0 || offer.kilometers > 0">
              <div class="info-grid-label">
                Kms
              </div>
              <div class="info-grid-value">
                {{ offer.kilometers ? offer.kilometers : "-" }}
              </div>
            </div>

            <template v-if="offer.subtype === 'order_muvin' && offer.part.origin">
              <div>
                <div class="info-grid-label">
                  Establecimiento origen
                </div>
                <template>
                  <div data-test="nameOrganization" class="info-grid-value">
                    {{ offer.part.origin.name }} ({{ offer.part.origin.address + ', ' + offer.part.origin.city + ', ' + offer.part.origin.state }})
                  </div>
                </template>
              </div>
            </template>

            <template v-if="offer.subtype === 'order_muvin'">
              <div>
                <div class="info-grid-label">
                  Organización destino
                </div>
                <template>
                  <div data-test="nameOrganization" class="info-grid-value">
                    {{ offer.part.destinationOrganization.businessName }} ({{ offer.part.destinationOrganization.city + ', ' + offer.part.destinationOrganization.state}})
                  </div>
                </template>
              </div>
            </template>
            
            <div>
              <div class="info-grid-label">
                Resolucíon de conflictos
              </div>
              <div class="info-grid-value">
                <span>{{ offer.conflictResolution }}</span>
              </div>
            </div>

            <div>
              <div class="info-grid-label">
                Fecha de publicación
              </div>
              <div class="info-grid-value">
                <span>{{ parseDate(offer.publishedAt) }}</span>
              </div>
            </div>

            <div>
              <div class="info-grid-label">
                Fecha de vigencia
              </div>
              <div class="info-grid-value">
                <span>{{ parseDate(offer.dueAt) }}</span>
              </div>
            </div>
          </div>

          <div v-if="offer.subtype === 'order_muvin'">
            <h4>
              Datos de entrega
            </h4>
            <div class="details-grid-delivery-schedule-lines" v-for="(dsl, index) in offer.deliveryScheduleLines" :key="index">
              <div>
                <div data-test="slaughterWeightid" class="info-grid-label">
                  Fecha
                </div>
                <div class="info-grid-value">
                  <div class="wrapper">
                    {{ new Date(dsl.deliveryDay.replace(/-/g, '\/')).toLocaleString().split(",")[0] }}
                  </div>
                </div>
              </div>

              <div>
                <div class="info-grid-label">
                  Cantidad
                </div>
                <div class="info-grid-value">
                  <div class="wrapper" v-if="dsl.quantity != 0 && dsl.quantity != null">
                    {{ dsl.quantity }}
                    <span v-if="offer.subtype === 'order_muvin' && dsl.finalQuantity != null && dsl.finalQuantity > dsl.quantity" class="wrapper" style="color: green">
                      +{{ dsl.finalQuantity - dsl.quantity }}
                    </span>
                    <span v-if="offer.subtype === 'order_muvin' && dsl.finalQuantity != null && dsl.finalQuantity < dsl.quantity" class="wrapper" style="color: #e30000">
                      {{ dsl.finalQuantity - dsl.quantity }}
                    </span>
                  </div>
                  <div v-else>
                    <span class="offer-muvin-tag-created-from"><b>Creada desde muvin</b></span>
                  </div>
                </div>
              </div>

              <div>
                <div class="info-grid-label">
                  Cantidad final
                </div>
                <div class="info-grid-value" v-if="dsl.finalQuantity != 0">
                  <div class="wrapper">
                    {{ dsl.finalQuantity != null ? dsl.finalQuantity : '-'}}
                  </div>
                </div>
                  <div v-else>
                    <span class="offer-muvin-tag-expired"><b>A Modificar/Rechazada</b></span>
                  </div>
              </div>

              <div>
                <div class="info-grid-label">
                  Destino
                </div>
                <div class="info-grid-value">
                  <div class="wrapper">
                    {{ dsl.establishment.name }}({{ dsl.establishment.address + ', ' + dsl.establishment.city + ', ' + dsl.establishment.state }})
                  </div>
                </div>
              </div>
            </div>
          </div>
        </we-tab>
        <!-- ***********************************HISTORIAL DE OPERACIONES*********************************** -->
        <we-tab
          data-test="operationsHistory"
          id="operationsHistory"
          :name="admin && windowWidth < 992 ? 'Historial': 'Historial de Operaciones'"
          :selected="openHistory"
          v-if="(offerHasNegotiations || offer.state != 'published') && offer.offerType != 'muvin_sell'"
        >
          <div class="offer-history-header">
            <div>Estado</div>
            <div>Empresa</div>
            <div>
              Negociación

              <span class="infotip">
                <button
                  class="infotip__host"
                  aria-controls="infotip-overlay"
                  aria-expanded="true"
                  aria-label="Help"
                  type="button"
                >
                  <vs-icon icon="help_outline" />
                </button>
                <span class="infotip__live-region" aria-live="off">
                  <div class="infotip__overlay" id="infotip-overlay">
                    <!-- overlay content -->
                    <div class="infotip__overlay-content tooltip-mw">
                      Se muestran únicamente los valores que difieren de la
                      oferta
                    </div>
                  </div>
                </span>
              </span>
            </div>
          </div>
          <div
            v-for="(historyPoint, index) in operationsHistory"
            :key="index"
            class="offer-history"
          >
            <template v-if="finishedOffer(historyPoint.state)">
              <div class="offer-history__finished">
                <div>
                  <strong :class="historyPoint.state">
                    {{
                      historyAction(
                        historyPoint.objectType,
                        historyPoint.state,
                        historyPoint.negotiation,
                        historyPoint.offer.id
                      )
                    }}
                  </strong>
                  <span>{{ localeDate(historyPoint.createdAt) }}</span>
                </div>
                <div
                  v-if="offerHasNoAcceptedNegotiations"
                  class="we-dropdown list"
                >
                  <button
                    @click="toggleDropdown($event)"
                    class="dropdown-toggle"
                    v-if="hideThreeDots(historyPoint, index)"
                  >
                    <vs-icon icon="more_vert" />
                  </button>

                  <div
                    class="we-dropdown-menu"
                    v-if="['finished', 'accepted'].includes(historyPoint.state)"
                  >
                    <button
                      v-if="offer.agroNacionPayment"
                      class="btn btn--with-icon btn--small pdf-download button-offer-dropdown"
                      @click.stop="goToAgroNacionUrl"
                    >
                      <img src="@/assets/images/agro_nacion.png" />
                      <span>Pago AgroNación</span>
                    </button>
                    <button
                      class="contact"
                      @click="openContactInformationPopup(historyPoint)"
                    >
                      <img
                        alt="Atributo negociable"
                        src="@/assets/images/contact.svg"
                      />
                      <span>Datos de contacto</span>
                    </button>
                    <template v-if="historyPoint.securePayment">
                      <!-- Usuario comprador -->
                      <button
                        v-if="
                          showReceivedMerchandiseBtn(
                            historyPoint.securePayment
                          ) &&
                            showSecurePaymentOptions(
                              historyPoint.buyer.organization.id
                            )
                        "
                        @click="
                          nextOnOperation = { ...historyPoint };
                          confirmPopup = true;
                        "
                        class="secure-payment"
                      >
                        <img
                          alt="Pago seguro"
                          src="@/assets/images/secure.svg"
                        />
                        Confirmar recepción de mercadería
                      </button>

                      <!-- Usuario vendedor -->
                      <button
                        v-else-if="
                          showPaymentBtn(historyPoint.securePayment) &&
                            showSecurePaymentOptions(
                              historyPoint.buyer.organization.id
                            )
                        "
                        @click="
                          nextOnOperation = { ...historyPoint };
                          confirmPopup = true;
                        "
                        class="secure-payment"
                      >
                        <img
                          alt="Pago seguro"
                          src="@/assets/images/secure.svg"
                        />
                        Informar transferencia realizada
                      </button>

                      <!-- Secure payment stage -->
                      <div v-else class="secure-payment">
                        <img
                          alt="Pago seguro"
                          src="@/assets/images/secure.svg"
                        />
                        {{
                          $t(
                            `securePayment.${historyPoint.securePayment.stage}`
                          )
                        }}
                      </div>

                      <a
                        href="https://www.rosporc.bcr.com.ar/documentos/GuiaDePagoSeguro-Rosporc.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="secure-payment-guide"
                      >
                        <img
                          alt="Pago seguro"
                          src="@/assets/images/guide.svg"
                        />
                        Guía pago seguro
                      </a>
                    </template>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="offer-history__action">
                <div
                  class="action-label c-tab-state" 
                  :class="historyPoint.state"
                >
                  
                  <span   >

                    {{
                      historyAction(
                        historyPoint.objectType,
                        historyPoint.state,
                        historyPoint.negotiation
                      )
                    }}
                  </span>
                </div>
                <div class="action-date">
                  {{ localeDate(historyPoint.createdAt) }}
                </div>
              </div>
              <div class="offer-history__part">
                <span class="hidden-desktop">
                  Empresa:
                </span>
                <div
                  class="part-name"
                  v-html="
                    offerHistoryActor(
                      historyPoint.displayName,
                      historyPoint.establishment,
                      historyPoint.displayLocation,
                      historyPoint.organization.id
                    )
                  "
                ></div>
              </div>
              <div class="offer-history__changes">
                <div
                  v-if="
                    offer.negotiableAttributes.price &&
                      historyPoint.price != offer.price && hiddenPricesNegotiation(historyPoint)
                  "
                >
                  <span>Precio s/IVA: </span
                  ><strong>$/kg {{ historyPoint.price }}</strong>
                </div>
                <div
                  v-if="
                    offer.negotiableAttributes.quantity &&
                      historyPoint.quantity != offer.quantity
                  "
                >
                  <span>Cantidad: </span
                  ><strong> {{ historyPoint.quantity }}</strong>
                </div>
                <div
                  v-if="
                    offer.negotiableAttributes.deliveryAtDestination &&
                      historyPoint.deliveryAtDestination !=
                        offer.deliveryAtDestination
                  "
                >
                  <span>Entrega en destino: </span
                  ><strong>
                    {{
                      historyPoint.deliveryAtDestination ? "Sí" : "No"
                    }}</strong
                  >
                </div>
                <div
                  v-if="
                    offer.negotiableAttributes.slaughterWeight &&
                      historyPoint.quality.slaughterWeight !=
                        offer.quality.slaughterWeight
                  "
                >
                  <span>Peso faena: </span
                  ><strong>
                    {{ historyPoint.quality.slaughterWeight }} (± 5) Kgs</strong
                  >
                </div>
                <div
                  v-if="
                    offer.negotiableAttributes.leanQuality &&
                      historyPoint.quality.leanQuality !=
                        offer.quality.leanQuality
                  "
                >
                  <span>Calidad magro: </span
                  ><strong> {{ historyPoint.quality.leanQuality }}</strong>
                </div>
                <div
                  v-if="
                    offer.negotiableAttributes.performance &&
                      historyPoint.quality.performance !=
                        offer.quality.performance
                  "
                >
                  <span>Rendimiento: </span
                  ><strong> {{ historyPoint.quality.performance }} %</strong>
                </div>
                <div
                  v-if="
                    offer.negotiableAttributes.dorsalFat &&
                      historyPoint.quality.dorsalFat != offer.quality.dorsalFat
                  "
                >
                  <span>Grasa dorsal: </span
                  ><strong> {{ historyPoint.quality.dorsalFat }} mm</strong>
                </div>
                <div
                  v-if="
                    offer.negotiableAttributes.securePayment.lock &&
                      !!historyPoint.securePayment != !!offer.securePayment
                  "
                >
                  <span>Pago seguro: </span
                  ><strong>
                    {{ historyPoint.securePayment ? "Sí" : "No" }}</strong
                  >
                </div>
                <!--<div><span>Pago AgroNación: </span><strong> {{  offer.agroNacionPayment? 'Sí' : 'No' }}</strong></div>-->
                <div
                  v-if="
                    showNegotiationChangeOnSecurePaymentFields(
                      historyPoint,
                      'percentage'
                    )
                  "
                >
                  <span>Porcentaje (PS): </span
                  ><strong>
                    {{ historyPoint.securePayment.percentage }} %</strong
                  >
                </div>
                <div
                  v-if="
                    showNegotiationChangeOnSecurePaymentFields(
                      historyPoint,
                      'lapse'
                    )
                  "
                >
                  <span>Fecha de pago (PS): </span
                  ><strong> {{ historyPoint.securePayment.lapse }} hs.</strong>
                </div>
              </div>
              <div>
                <div
                  class="we-dropdown list"
                  v-if="['finished', 'accepted', 'accept_pending'].includes(historyPoint.state) && showDotsOnConfirmation(historyPoint, index)"
                >
                  <button
                    @click="toggleDropdown($event)"
                    class="dropdown-toggle"
                  >
                    <vs-icon icon="more_vert" />
                  </button>

                  <div class="we-dropdown-menu">
                    <button
                      v-if="offer.agroNacionPayment"
                      class="btn btn--with-icon btn--small pdf-download button-offer-dropdown"
                      @click.stop="goToAgroNacionUrl"
                    >
                      <img
                        alt="Atributo negociable"
                        src="@/assets/images/agro_nacion.png"
                      />
                      <span>Pago AgroNación</span>
                    </button>
                    <button
                      class="btn btn--with-icon btn--small pdf-download"
                      @click.stop="negotiationPdfUrl(historyPoint.negotiation, historyPoint.offer)"
                    >
                      <img
                        alt="Atributo negociable"
                        src="@/assets/images/pdf.svg"
                      />
                      <span>Comprobante</span>
                    </button>

                    <button
                      class="contact"
                      @click="openContactInformationPopup(historyPoint)"
                    >
                      <img
                        alt="Atributo negociable"
                        src="@/assets/images/contact.svg"
                      />
                      <span>Datos de contacto</span>
                    </button>

                    <template v-if="historyPoint.securePayment">
                      <!-- Usuario comprador -->
                      <button
                        v-if="
                          showReceivedMerchandiseBtn(
                            historyPoint.securePayment
                          ) &&
                            showSecurePaymentOptions(
                              historyPoint.buyer.organization.id
                            )
                        "
                        @click="
                          nextOnOperation = { ...historyPoint };
                          confirmPopup = true;
                        "
                        class="secure-payment"
                      >
                        <img
                          alt="Pago seguro"
                          src="@/assets/images/secure.svg"
                        />
                        Confirmar recepción de mercadería
                      </button>

                      <!-- Usuario vendedor -->
                      <button
                        v-else-if="
                          showPaymentBtn(historyPoint.securePayment) &&
                            showSecurePaymentOptions(
                              historyPoint.buyer.organization.id
                            )
                        "
                        @click="
                          nextOnOperation = { ...historyPoint };
                          confirmPopup = true;
                        "
                        class="secure-payment"
                      >
                        <img
                          alt="Pago seguro"
                          src="@/assets/images/secure.svg"
                        />
                        Informar transferencia realizada
                      </button>

                      <!-- Secure payment stage -->
                      <div v-else class="secure-payment">
                        <img
                          alt="Pago seguro"
                          src="@/assets/images/secure.svg"
                        />
                        {{
                          $t(
                            `securePayment.${historyPoint.securePayment.stage}`
                          )
                        }}
                      </div>

                      <a
                        href="https://www.rosporc.bcr.com.ar/documentos/GuiaDePagoSeguro-Rosporc.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="secure-payment-guide"
                      >
                        <img
                          alt="Pago seguro"
                          src="@/assets/images/guide.svg"
                        />
                        Guía pago seguro
                      </a>
                    </template>
                  </div>
                </div>
              </div>
              <div>
                <OperationTooltip v-if="admin" :operation="historyPoint" />
              </div>
            </template>
          </div>

          <vs-popup
            v-if="popUpOperation"
            title="Datos de contacto"
            :active.sync="contactInformation"
            class="contact-information"
          >
            <div class="content">
              <div class="">
                <label>Email entidad:</label>
                <strong>{{
                  contactPartIsSeller()
                    ? popUpOperation.seller.organization.email
                    : popUpOperation.buyer.organization.email
                }}</strong>
              </div>

              <div>
                <label>Teléfono:</label>
                <strong>{{
                  contactPartIsSeller()
                    ? popUpOperation.seller.organization.phone
                    : popUpOperation.buyer.organization.phone
                }}</strong>
              </div>

              <div>
                <label>Empresa:</label>
                <strong>{{
                  contactPartIsSeller()
                    ? popUpOperation.seller.organization.businessName
                    : popUpOperation.buyer.organization.businessName
                }}</strong>
              </div>

              <div>
                <label>Email operador:</label>
                <strong>{{
                  contactPartIsSeller()
                    ? popUpOperation.sellerOperator.email
                    : popUpOperation.buyerOperator.email
                }}</strong>
              </div>
            </div>
          </vs-popup>

          <vs-popup
            title="Pago seguro"
            :active.sync="confirmPopup"
            :button-close-hidden="true"
            class="confirm-action"
          >
            <div class="alert info">
              <vs-icon icon="warning"></vs-icon>
              <span v-if="nextOnOperation.securePayment"
                >Usted está indicando que
                {{
                  nextOnOperation.securePayment.stage ==
                  "received_surety_transfer"
                    ? "recibió la mercadería"
                    : "realizó el pago correspondiente"
                }}, ¿está seguro?. Esta acción no puede ser cancelada.</span
              >
            </div>

            <div class="footer">
              <button @click="confirmPopup = false" class="cancel">
                Cancelar
              </button>
              <button
                class="confirm"
                @click="nextStage(nextOnOperation.securePayment.id)"
              >
                Confirmar
              </button>
            </div>
          </vs-popup>
        </we-tab>

         <!-- *********************************** TAB DE DESHABILITACIÓN DE OFERTAS *********************************** -->
        <we-tab
          id="disableFromDashboard"
          :name="admin && windowWidth < 992 ? 'Deshabilitar': 'Deshabilitar de Dashboard'"
          v-if="admin"
        >
        <CancelOfferFromDashboard :offer="originalOffer" />
        
        </we-tab>

      </we-tabs>
    </div>
  </transition>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import OfferNegotiations from '@/components/OfferNegotiations.vue'
import { mapMutations, mapState } from 'vuex'
import OfferOperations from './offers/OfferOperations.vue'
import WeTabs from '@/lib/WebExperto/components/WeTabs.vue'
import WeTab from '@/lib/WebExperto/components/WeTab.vue'
import CancelOfferFromDashboard from "./admin/CancelOfferFromDashboard.vue"
import OperationTooltip from '@/components/OperationTooltip.vue'

const offerDetail = gql`
  query offerDetail($offerId: Int!, $currentUserToken: String!) {
    offerDetail(offerId: $offerId, currentUserToken: $currentUserToken) {
      alreadyPublishedInMuvin
      acceptedAt
      bestPrice
      conflictResolution
      canCancel
      canOperate
      cancelledAt
      description
      agroNacionPayment
      category {
        name
      }
      deliveryAtDestination
      displayName
      displayLocation
      dueAt
      hideIdentity
      id
      isParticipant
      kilometers
      negotiableAttributes {
        deliveryAtDestination
        dorsalFat
        leanQuality
        performance
        price
        quantity
        securePayment {
          lapse
          lock
          percentage
        }
        slaughterWeight
      }
      negotiations {
        id
      }
      offerType
      operationsCount
      organization {
        businessName
        city
        comments
        commercialAddress
        country
        cuit
        email
        id
        incomeTaxSituation
        ivaSituation
        logo
        mainActivity
        phone
        state
        zipcode
      }
      part {
        destination {
          city
          id
          name
          state
          address
        }
        opener {
          canBuy
          canSell
          id
          organization {
            businessName
            city
            id
            state
          }
          organizationId
        }
        origin {
          name
          city
          id
          state
          address
        }
        destinationOrganization{
          businessName
          city
          state
        }
      }
      deliveryScheduleLines{
        deliveryDay
        quantity
        finalQuantity
        establishment{
          name
          city
          state
          address
        }
      }
      paymentDeadline
      paymentMethod
      pendingOperations
      price
      publishedAt
      quality {
        dorsalFat
        leanQuality
        performance
        qualitySegment
        slaughterWeight
      }
      quantity
      quantityLeft
      securePayment {
        lapse
        percentage
        stage
      }
      state
      subtype
      week
    }
  }
`

const listNegotiations = gql`
  query listNegotiations($offerId: Int!, $currentUserToken: String!) {
    listNegotiations(offerId: $offerId, currentUserToken: $currentUserToken) {
      canCancel
      canOperate
      createdAt
      pdfUrl
      deliveryAtDestination
      history {
        canCancel
        createdAt
        deliveryAtDestination
        id
        offeror {
          id
        }
        price
        quality {
          dorsalFat
          leanQuality
          performance
          qualitySegment
          slaughterWeight
        }
        quantity
        receiverId
        senderId
        slaughterWeight
        state
      }
      id
      offeror {
        active
        activity
        city
        cuig
        id
        marketRole
        name
        number
        organization {
          id
          businessName
        }
        renspa
        ruca
        state
        users {
          id
        }
        zipcode
      }
      price
      quality {
        dorsalFat
        leanQuality
        performance
        qualitySegment
        slaughterWeight
      }
      quantity
      receiverId
      securePayment {
        id
        lapse
        percentage
        stage
      }
      senderId
      origin {
        id
      }
      destination {
        id
      }
      slaughterWeight
      state
    }
  }
`

const offerOperations = gql`
  query offerOperations($offerId: Int!, $currentUserToken: String!) {
    offerOperations(offerId: $offerId, currentUserToken: $currentUserToken) {
      activityId
      createdAt
      deliveryAtDestination
      displayName
      displayLocation
      dueAt
      establishment {
        state
        city
        organization {
          id
        }
      }
      hideIdentity
      initialPrice
      issuer {
        id
        organization {
          commercialAddress
        }
      }
      negotiableAttributes {
        deliveryAtDestination
        dorsalFat
        leanQuality
        performance
        price
        quantity
        slaughterWeight
      }
      negotiation {
        id
        responder
        pdfUrl
        state
      }
      objectType
      offer {
        id
        pdfUrl
      }
      offerType
      operationId
      organization {
        id
      }
      parentNegotiationId
      parentOfferId
      part {
        destination {
          name
        }
        opener {
          id
        }
        origin {
          name
        }
      }
      paymentDeadline
      paymentMethod
      price
      publishedAt
      securePayment {
        id
        lapse
        percentage
        stage
      }
      quality {
        dorsalFat
        leanQuality
        performance
        qualitySegment
        slaughterWeight
      }
      quantity
      state
      sessionHistory {
        userHistoryEmail
        id
        ip
        device
      }
      week
      seller {
        organization {
          id
          email
          phone
          businessName
        }
      }
      buyer {
        organization {
          id
          email
          phone
          businessName
        }
      }
      buyerOperator {
        email
      }
      sellerOperator {
        email
      }
    }
  }
`

const nextSecurePaymentStage = gql`
  mutation nextSecurePaymentStage($id: Int!, $currentUserToken: String!) {
    nextSecurePaymentStage(id: $id, currentUserToken: $currentUserToken) {
      success
    }
  }
`

const transactionateOffer = gql`
  mutation transactionateOffer(
    $currentUserToken: String!
    $offerId: Int!
    $action: String!
  ) {
    transactionateOffer(
      currentUserToken: $currentUserToken
      offerId: $offerId
      action: $action
    ) {
      code
      message
      success
    }
  }
`

export default {
  name: 'delivery-details',
  props: {
    admin: {
      type: Boolean,
      required: false,
      default: false
    },
    filterType: {
      type: String,
      required: false,
      default: 'activeOffers'
    },
    originalOffer:{
        type: Object,
        required: false
    }
  },
  components: {
    'offer-negotiations': OfferNegotiations,
    'we-tabs': WeTabs,
    'we-tab': WeTab,
    OfferOperations,
    CancelOfferFromDashboard,
    OperationTooltip,
  },
  data () {
    return {
      activeSidebar: false,
      action: '',
      offerId: '',
      offerAction: '',
      offer: { quality: {} },
      negotiations: [],
      negotiation: {},
      canOperate: false,
      operationsHistory: [],
      openHistory: false,
      confirmPopup: false,
      contactInformation: false,
      popUpOperation: '',
      nextOnOperation: {},
      windowWidth: window.innerWidth
    }
  },
  mounted() {
    if (this.admin) {
        window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth;
    });
    }
  
  },
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser
    }),
    offerHasNegotiations () {
      return !!this.negotiations.length
    },
    offerHasNoAcceptedNegotiations () {
      if (this.negotiations.length) {
        if (!this.negotiations.filter(neg => neg.state == 'accepted').length) {
          return true
        }
      } else {
        return true
      }
    },
    
    activeState () {
      return [
        'published',
        'pending',
        'in_negotiation',
        'accept_pending'
      ].includes(this.offer.state)
    },
    showQuantityLeft () {
      if (this.offer.quantityLeft != this.offer.quantity) {
        return `<span class="quantity">${this.offer.quantityLeft}</span> <span> de ${this.offer.quantity} </span>`
      }
      return '<span class="quantity">' + this.offer.quantity + '</span>'
    },
    acceptPendingArray () {
      return this.operationsHistory.filter(s => s.state === 'accept_pending')  
    },
    finishedArray () {
      return this.operationsHistory.filter(e => e.state === 'finished')
    }
  },
  methods: {
    ...mapMutations('Offer', ['setOfferInSidebar']),
    offerFinalQuantity(){
      if (this.offer.deliveryScheduleLines.length == 1){
        return this.offer.deliveryScheduleLines[0].finalQuantity
      }
      else{
        var result;
        result = this.offer.deliveryScheduleLines.every(function (dsl) { return dsl.finalQuantity != null; });
        if(result){
          var sum = 0
          this.offer.deliveryScheduleLines.forEach(function(dsl) {
            sum = sum + parseInt(dsl.finalQuantity)
          })
          return sum
        }else{
          return null
        }
      }
    },
    parseDate (date) {
      return new Date(Date.parse(date) + 3.6e6 * 3).toLocaleDateString()
    },
    contactPartIsSeller () {
      return (
        this.popUpOperation.buyer.organization.id ==
        this.currentUser.organizationId
      )
    },
    hideButtonToAdmin(){
      if (this.currentUser.admin) {
        return false
      } 
      return true
    },
    seeInitialActionBtns () {
      return (
        ['accept_pending'].includes(this.offer.state) && this.filterType !== 'finishedNegotiations'
      )
    },
    showEstablishmentOrigin(){
      if (this.offer.part.origin != null) {
        if (this.currentUser.admin) {
          return true
        }
        let establishmentIds = this.currentUser.organization.establishments.map(e => e.id) 
        if (!establishmentIds.includes(this.offer.part.origin.id) && !establishmentIds.includes(this.offer.part.destination.id)){
        return false
        }
      } else {
        return false
      }
      return true
    },
    showEstablishmentDestination(){
      if (this.offer.part.destination != null) {
        if (this.currentUser.admin) {
          return true
        }
        let establishmentIds = this.currentUser.organization.establishments.map(e => e.id) 
        if (!establishmentIds.includes(this.offer.part.destination.id) && !establishmentIds.includes(this.offer.part.origin.id)) {
        return false
        }
      } else {
        return false
      }
      return true
    },
    seeLabelWaiting () {
      if(this.filterType != 'finishedNegotiations'){
        return ['accept_pending'].includes(this.offer.state)
      }
        return false
    },
    offerOrgEqualCurrentOrg () {
      return (
        this.offer.part.opener.organizationId ===
        this.currentUser.organizationId
      )
    },
    hiddenPricesNegotiation(historyPoint){
      if (['accept_rejected', 'accept_pending', 'published'].includes(historyPoint.state)) {
        return false
      }
      return true
    },
    cleanActions () {
      this.offerAction = ''
      this.negotiationAction = ''
      this.inNegotiation = {}
    },
    showNegotiationChangeOnSecurePaymentFields (operation, field) {
      if (
        this.offer.negotiableAttributes.securePayment[field] &&
        operation.securePayment
      ) {
        if (!this.offer.securePayment) {
          return true
        }
        if (operation.securePayment[field] != this.offer.securePayment[field]) {
          return true
        }
      }
      return false
    },
    showReceivedMerchandiseBtn (securePayment) {
      if (securePayment) {
        if (securePayment.stage == 'received_surety_transfer') {
          return true
        }
      }
      return false
    },
    showPaymentBtn (securePayment) {
      if (securePayment) {
        if (securePayment.stage == 'pending_payment_notification') {
          return true
        }
      }
      return false
    },
    showSecurePaymentOptions (operationOrgId) {
      if (operationOrgId == this.currentUser.organizationId) {
        return true
      }
      return false
    },
    hasNegotiationPdf (negotiation, state) {
      return false //se agrega para evitar mostrar el pdf por operacion
      if (negotiation) {
        if (negotiation.pdfUrl && state == 'accepted') {
          return true
        }
      }
      return false
    },
    negotiationPdfUrl (negotiation, offer) {
      if (negotiation) {
        location.replace(
          `${process.env.VUE_APP_RAILS_PATH}${negotiation.pdfUrl}.pdf`
        )
      }else{
        location.replace(
          `${process.env.VUE_APP_RAILS_PATH}${offer.pdfUrl}.pdf`
        )
      }
    },
    negotiateAttribiute (attr) {
      this.$refs.offerOperations.negotiateAttr(attr)
    },
    localeDate (str) {
      return new Date(Date.parse(str) + 3.6e6 * 3).toLocaleDateString()
      // return (new Date(str.replace(/-0300/, '').trim())).toLocaleString()
    },
    localePrice (price) {
      return '$/kg ' + price.toLocaleString('es', { minimumFractionDigits: 2 })
    },
    localeNumber (number) {
      return number.replace('.', ',')
    },
    getOffer (id) {
      axios
        .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
          params: {
            query: print(offerDetail),
            variables: {
              currentUserToken: localStorage.getItem('USER_TOKEN'),
              offerId: id
            }
          }
        })
        .then(res => {
          if (!res.data.errors) {
            this.offer = res.data.data.offerDetail
            } else {
            console.log(res.data.errors)
          }
        })
    },

    getNegotiations (id) {
      axios
        .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
          params: {
            query: print(listNegotiations),
            variables: {
              currentUserToken: localStorage.getItem('USER_TOKEN'),
              offerId: id
            }
          }
        })
        .then(res => {
          if (!res.data.errors) {
            this.negotiations = res.data.data.listNegotiations
          } else {
            console.log(res.data.errors)
          }
        })
    },
    getOperationsHistory (id) {
      axios
        .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
          params: {
            query: print(offerOperations),
            variables: {
              currentUserToken: localStorage.getItem('USER_TOKEN'),
              offerId: id
            }
          }
        })
        .then(res => {
          if (!res.data.errors) {
            this.operationsHistory = res.data.data.offerOperations
          }
        })
    },
    nextStage (id) {
      axios
        .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
          query: print(nextSecurePaymentStage),
          variables: {
            id: id,
            currentUserToken: localStorage.getItem('USER_TOKEN')
          }
        })
        .then(res => {
          if (!res.data.errors) {
            if (res.data.data.nextSecurePaymentStage.success) {
              this.confirmPopup = false
              this.nextOnOperation = {}
              this.$vs.notify({
                title: 'Notificación enviada',
                time: 8000,
                // text: 'Su negociación ha sido enviada',
                color: '#50b83d',
                position: 'top-right',
                icon: 'check_circle'
              })
              this.getOperationsHistory(this.offer.id)
            }
          }
        })
    },
    getPendingNegotiations (offer) {
      let pendingNegotiations = 0
      if (['finished', 'expired', 'cancelled'].includes(offer.state)) {
        return false
      }
      if (offer.pendingOperations) {
        if (offer.negotiations.length > 0) {
          pendingNegotiations = offer.negotiations.filter(
            ng =>
              ng.state === 'pending' &&
              ng.senderId !== this.currentUser.organizationId
          ).length
        } else if (
          this.currentUser.organizationId != offer.part.opener.organizationId
        ) {
          pendingNegotiations = 1
        }
      }
      return pendingNegotiations
    },
    open (offerId) {
      this.offer = {}
      this.getOffer(offerId)
      this.getNegotiations(offerId)
      this.getOperationsHistory(offerId)
      this.activeSidebar = true
    },

    notify (action) {
      if (action != 'negotiate!') {
        var title = 'Oferta ' + this.$t(`offer.action.${action}`)
        var text =
          'La operación ha sido ' +
          this.$t(`offer.action.${action}`) +
          ' con éxito'
      } else {
        var title = 'Confirmación enviada'
        var text = 'Su confirmación ha sido enviada'
      }
      this.$vs.notify({
        title: title,
        time: 8000,
        text: text,
        color: '#50b83d',
        position: 'top-right',
        icon: 'check_circle'
      })
    },

    closeAndCleanOffer () {
      this.setOfferInSidebar({})
      this.activeSidebar = false
      this.$emit('reload-published-offers')
    },

    formatWeek (week) {
      return week.toString().slice(-2) + '-' + week.toString().substr(0, 4)
    },
    offerHistoryActor (name, establishment, region, orgId) {
      if (establishment.organization.id == orgId && region) {
        return region
      }
      if (name) {
        return `<div>${name}</div> (${establishment.state}, ${establishment.city})`
      }
      return `${establishment.state}, ${establishment.city}`
    },
    hideThreeDots(historyPoint, index){
      if (this.offer.state === 'finished' && this.operationsHistory[index + 1].state === 'rejected') {
        return false
      }
      return true
    },
    showDotsOnConfirmation(historyPoint, index){
      // se agregó esta condicion para arreglar de que no salgan los 3 puntos en operaciones sin concretar.
      if(historyPoint.state == 'accept_pending' && index > 0 && this.operationsHistory[index-1].state === 'accept_rejected'){
        return false
      }
      if(this.offer.state == 'finished'){
          return true
      }

        
      let acceptedArray = this.operationsHistory.filter(e => e.state === 'accepted' && historyPoint.operationId == e.operationId)
      let negotiationAccepted = this.operationsHistory.filter(n => n.negotiation !== null && n.negotiation.state === 'accepted')
      let isAcceptPendingTheLastOperation = this.finishedArray.length > 0 && this.operationsHistory[1].state === 'accept_pending' && negotiationAccepted.length > 0 && historyPoint.state === 'finished' && index === 0
      let isAcceptedOperation = acceptedArray.length > 0;
      if(this.currentUser.organization) {
        let isParticipant = historyPoint.seller.organization.businessName === this.currentUser.organization.businessName || historyPoint.buyer.organization.businessName === this.currentUser.organization.businessName;
      }
      else {
        let isParticipant = false;
      }
      let isAcceptPendingRejected = false
      if (index > 0) {
        isAcceptPendingRejected = historyPoint.state === 'accept_pending' && this.operationsHistory[index - 1].state === 'accept_rejected' 
      }
      let isOfferFinished = this.offer.state === 'finished' && !isAcceptPendingRejected;
      
      // en un futuro sprint esto deberia cambiar, ya que la posicion 1 de accept_pending podria contener otro estado
      if (isAcceptPendingTheLastOperation || isAcceptedOperation || isParticipant && isOfferFinished && this.offer.negotiations.length > 1 && this.offer.part.origin !== null) {
        return true
      }
      return false
    },
    historyAction (type, state, negotiation) {
      var name = type
      var action = state
      if (type === 'offer') {
        if (state === 'in_negotiation') {
          name = 'negotiation'
          action = 'created'
        }
      }
      if (type === 'negotiation') {
        if (action === 'in_negotiation') {
          if (negotiation.responder === this.currentUser.organizationId) {
            action = 'sent'
          } else {
            action = 'received'
          }
        }
      }

      if (action === 'order_muvin_pending') {
          return `Orden Muvin Pendiente`
        }
      if (action === 'order_muvin_published') {
          return `Orden Muvin Publicada`
        }
      if (action === 'order_muvin_finished') {
          return `Orden Muvin Finalizada`
        }
      
      if (action === 'order_muvin_expired') {
          return `Orden Muvin Vencida`
        }
      return `${this.$t(`operationHistory.${name}`)} ${this.$t(
        `operationHistory.action.${action}`
      )}`
    },
    finishedOffer (state) {
      return ['finished', 'cancelled', 'expired'].includes(state)
    },
    toggleDropdown (event) {
      let clickedDropdown = event.target.closest('.we-dropdown')
      let activeDropdown = document.querySelector('.we-dropdown.is-visible')
      if (
        event.target.matches('.we-dropdown-menu') ||
        clickedDropdown === null ||
        clickedDropdown != activeDropdown
      ) {
        if (activeDropdown) {
          activeDropdown.classList.remove('is-visible')
        }
      }

      clickedDropdown.classList.toggle('is-visible')
      event.stopPropagation()
    },
    onClickOutside (event) {
      if (
        event.target.matches('.we-dropdown-menu') ||
        event.target.closest('.we-dropdown') === null
      ) {
        let activeDropdown = document.querySelector('.we-dropdown.is-visible')
        if (activeDropdown) {
          activeDropdown.classList.remove('is-visible')
        }
      }
    },
    openContactInformationPopup (operation) {
      this.contactInformation = true
      this.popUpOperation = { ...operation }
    },
    goToAgroNacionUrl () {
      window.open(
        'https://agroconsulta.nacionservicios.com.ar/cgi-bin/wspd_cgi.sh/WService=wsagroconsulta/index.r',
        '_blank'
      )
    },
    takeActionOnOffer () {
    
            axios
        .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
          query: print(transactionateOffer),
          variables: {
            currentUserToken: localStorage.getItem('USER_TOKEN'),
            offerId: this.offer.id,
            action: this.offerAction
          }
        })
        .then(res => {
          if (!res.data.errors) {
            if (res.data.data.transactionateOffer.success) {
              this.error = ''
              this.$emit('close-sidebar')
              this.notify(this.offerAction)
              this.closeAndCleanOffer()
            } else {
              if (res.data.data.transactionateOffer.code == 'unauthorized') {
                this.$vs.notify({
                  title: 'No tiene permisos para realizar esta acción',
                  time: 3000,
                  // text: 'Por favor intente nuevamente',
                  color: '#DE3618',
                  position: 'top-right',
                  icon: 'error'
                })
              } else {
                console.log(res.data.data.transactionateOffer.code)
              }
            }
          }
        })
    }
  },
  created () {
    document.addEventListener('click', this.onClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onClickOutside)
  }
}
</script>

<style scoped>
.tooltip-mw {
  max-width: 180px;
}
</style>